import { useSEO } from "@/hooks/useSEO"
import { ComplianceSection } from "@/sections/ComplianceSection"
import { CTASection } from "@/sections/CTASection"
import { FeaturesSection } from "@/sections/FeaturesSection"
import { GatewaySection } from "@/sections/GatewaySection"
import { HeroSection } from "@/sections/HeroSection"
import { OnboardingSection } from "@/sections/OnboardingSection"
import { PricingSection } from "@/sections/PricingSection"
import { StatsBar } from "@/sections/StatsBar"
import { TestimonialsSection } from "@/sections/TestimonialsSection"
import { TrustedByTicker } from "@/sections/TrustedByTicker"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/")({
  component: Index,
})

function Index() {
  useSEO({
    title: "Payments that scale with you",
    description:
      "Orchestrate empowers modern businesses to scale, innovate, and manage complex payment flows through a single, unified API. PCI DSS, GDPR, SOC 2 compliant.",
    canonical: "https://orchestrate.global/",
  })

  return (
    <>
      <HeroSection />
      <StatsBar />
      <section className="mx-auto max-w-7xl bg-white px-6 lg:px-8">
        <TrustedByTicker direction="left" speed={18} showTitle />
        <TrustedByTicker direction="right" speed={22} showTitle={false} />
      </section>
      <FeaturesSection />
      <GatewaySection />
      <ComplianceSection />
      <TestimonialsSection />
      <PricingSection />
      <OnboardingSection />
      <CTASection />
    </>
  )
}
